module.exports = __webpack_public_path__ + "img/cd.1ceb0bdc.png";